import { useRolePermission } from '~/composables/useRolePermission'

export default defineNuxtRouteMiddleware((to) => {
  // only enable if roles and permission feature flag is enabled
  const { isManageUsersEnabled } = useFeatureFlag()
  if (!isManageUsersEnabled()) {
    return
  }

  const { $store } = useNuxtApp()
  const { canView } = useRolePermission()
  const userRoles = $store.userSettings.userRoles

  const pagePermission = to.meta.pagePermission

  // No user roles or permission, redirect to error page
  if (!userRoles?.length || !pagePermission) {
    return navigateTo('/errors/ErrorPermission')
  }

  const hasPermission = userRoles.some((userRole) => {
    return canView(pagePermission, userRole)
  })

  if (!hasPermission) {
    return navigateTo('/errors/ErrorPermission')
  }
})
